module.exports = __webpack_public_path__ + "static/media/imgMarketing02.71cdde24.png";